<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Elomark Users</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button v-if="abilities.can('create', 'elomark-users')"
            icon="add"
            @click="addElomarkUser"
            color="danger"
            type="border"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="12">
          <span class="p-2">Status: </span>
          <v-select
            class="filter ml-2"
            v-model="selected_user_status"
            :options="userStatusList"
            label="user_status"
          />
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1">
            <span>Search: </span>
          </div>

          <ElomarkUserAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchElomarkUser"
            :searchOn="'elomark_user'"
            @event-name="handleChildEvent"
          ></ElomarkUserAutocomplete>
          <vs-icon
            class="pl-5 pointer"
            icon="cancel"
            @click="resetElomarkUser"
            size="small"
          ></vs-icon>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="12">
          <span class="ml-20 p-2">Role: </span>
          <v-select
            class="filter ml-2"
            v-model="selected_role"
            label="role"
            :options="elomarkRoleTypes"
          />
           <vs-button
                    class="ml-5"
            icon="refresh"
            @click="resetAll"
            color="primary"
            >Reset</vs-button
          >

          <v-select class="ml-12" v-model="per_page" :options="size_per_page" />


          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="elomarkUsers"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="company_registration_number">Full Name</vs-th>
          <!-- <vs-th sort-key="company_name">Role</vs-th> -->
          <vs-th sort-key="company_name">Desk Phone</vs-th>
          <vs-th sort-key="company_name">Mobile</vs-th>
          <vs-th sort-key="registered_office_county">Email</vs-th>
          <vs-th sort-key="registered_office_county">status</vs-th>
          <vs-th sort-key="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].first_name">
              {{ data[indextr].first_name + " " + data[indextr].surname }}
            </vs-td>
            <!-- <vs-td :data="data[indextr].user_role">
              {{ data[indextr].user_role.replace("_", " ") }}
            </vs-td> -->
            <vs-td :data="data[indextr].desk_phone">
              {{ data[indextr].desk_phone }}
            </vs-td>
            <vs-td :data="data[indextr].mobile_no">
              {{ data[indextr].mobile_no }}
            </vs-td>
            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>
            <vs-td :data="data[indextr].user_status">
              {{ data[indextr].user_status }}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              <vs-icon v-if="abilities.can('read', 'elomark-users')"
                class="ml-10 removeButton"
                @click="viewElomarkUser(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon v-if="abilities.can('update', 'elomark-users')"
                class="ml-10 removeButton"
                @click="editElomarkUser(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon v-if="abilities.can('delete', 'elomark-users')"
                class="ml-10 removeButton"
                @click="confirmDeleteElomarkUser(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
                      abilities : null,

    companySearchComponentKey: 0,
    selected: [],
    log: [],
    elomarkUsers: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    userStatusList: [],
    selected_user_status: "All",
    elomarkRoleTypes: [],
    selected_role: 'All',
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    ElomarkUserAutocomplete,
    "v-select": vSelect,
    moduleElomarkUserManagement
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
        selected_role: function(val) {
                    if(val != 'All')
      this.fetchElomarkUsersWithFilter();
    },
        selected_user_status: function(val) {
          if(val != 'All')
      this.fetchElomarkUsersWithFilter();
    }
  },
  methods: {
    resetAll(){
       this.selected_user_status = 'All'
       this.selected_role='All'
       this.resetElomarkUser()

    },
    getElomarkRoleTypes() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkRoleTypes")
        .then(res => {
          this.elomarkRoleTypes = res.data;

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    resetElomarkUser() {
      this.fetchElomarkUsers();
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.fetchElomarkUsers();
    },
    getElomarkUserStatus() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkUserStatus")
        .then(res => {
          this.userStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    async showStatusName(statusId) {
      let result = await this.$store
        .dispatch("elomarkUsersManagement/fetchStatus", statusId)
        .then(res => {
          return res;
        })
        .catch(err => {
          console.log(err);
        });

      return result;
    },
    searchElomarkUser(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/searchElomarkUser", inputValue)
        .then(response => {
          if (response) {
            let data = moduleElomarkUserManagement.state.elomark_user;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].first_name + " " + data[property].surname
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addElomarkUser() {
      this.$router.push({ path: "/elomark-user/add" });
    },
    handleSearch(searching) {
      // console.log(`The user searched for: ${searching}`);
    },
    handleSort(key, active) {
      // console.log(`the user ordered: ${key} ${active}`);
    },
    viewElomarkUser(id) {
      this.$router.replace("/elomark-user/" + id);
    },
    editElomarkUser(id) {
      this.$router.replace("/elomark-user/edit/" + id);
    },
    handleChildEvent() {
      let self = this
      self.elomarkUsers = moduleElomarkUserManagement.state.elomark_users.datas.filter(
            function(ele) {
              if(ele.user_status){
                self.showStatusName(ele.user_status).then(function(data) {
                if (data) {
                  ele.user_status = data.data.user_status;
                }
              });
              }else{
                ele.user_status = null;
              }
              return ele;
            })
    },
    confirmDeleteElomarkUser(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete ElomarkUser`,
        accept: this.deleteElomarkUser,
        acceptText: "Delete"
      });
    },
    deleteElomarkUser() {
      this.$store
        .dispatch("elomarkUsersManagement/removeElomarkUser", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchElomarkUsers();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "ElomarkUser Deleted",
        text: "The User was successfully deleted"
      });
    },
    fetchElomarkUsers() {
      this.$store
        .dispatch(
          "elomarkUsersManagement/fetchAllElomarkUsers",
          this.paginationAttr
        )
        .then(res => {
            let self = this;
            self.elomarkUsers = moduleElomarkUserManagement.state.elomark_users.datas.filter(
            function(ele) {
              if(ele.user_status){
                self.showStatusName(ele.user_status).then(function(data) {
                if (data) {
                  ele.user_status = data.data.user_status;
                }
              });
              }else{
                ele.user_status = null;
              }
              return ele;
            }
          );
          this.total = moduleElomarkUserManagement.state.elomark_users.total;
          this.per_page =
            moduleElomarkUserManagement.state.elomark_users.per_page;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchElomarkUsersWithFilter() {
      let filter = {}
      filter.status = this.selected_user_status
      filter.role = this.selected_role
      this.$store
        .dispatch(
          "elomarkUsersManagement/fetchAllElomarkUsersWithFilter",
          filter
        )
        .then(res => {
            let self = this;
            self.elomarkUsers = moduleElomarkUserManagement.state.elomark_users.filter(
            function(ele) {
              if(ele.user_status){
                self.showStatusName(ele.user_status).then(function(data) {
                if (data) {
                  ele.user_status = data.data.user_status;
                }
              });
              }else{
                ele.user_status = null;
              }
              return ele;
            }
          );
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
    this.fetchElomarkUsers();
    this.getElomarkRoleTypes();
    this.getElomarkUserStatus()
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
